import { render } from "./Welcome.vue?vue&type=template&id=219107fe&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=219107fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-219107fe"

export default script